import {computed, ref} from '@vue/composition-api'

let now = ref(null)
let isUpdating = false

function update () {
  if (isUpdating) {
    requestAnimationFrame(() => {
      now.value = Date.now()
      update()
    })
  }
}

export default function useNow () {
  if (!isUpdating) {
    isUpdating = true
    update()
  }

  return {
    now: computed(() => now.value),
    stopNow: () => isUpdating = false,
  }
}
